export function fetchGames(idDivision) { return { type: 'GAMES/FETCH', idDivision } }
export function addGame(game) { return { type: 'GAMES/ADD', game } }
export function deleteGame(Id) { return { type: 'GAMES/DELETE', Id } }
export function markGameAsDeleted(Id) { return { type: 'GAMES/MARK_AS_DELETED', Id } }
export function updateGame(game) { return { type: 'GAMES/UPDATE', game } }
export function clearGames() { return { type: 'GAMES/CLEAR' } }
export function updateScore(game, notify) { return { type: 'GAMES/SCORE/UPDATE', game, notify } }
export function fetchGameDetails(idGame, idSeason) { return { type: 'GAMES/FETCH/DETAILS', idGame, idSeason } }